import { type Features } from '@melio/subscriptions-api';

import { usePlanInfo, useSubscriptionPlanTier } from '../../../utils';
import { useContextualMessages } from './useContextualMessages';
import { useFirstPlanWithFeature } from './useFirstPlanWithFeature';

export type UseContextualPlansProps = {
  featureName: keyof Features;
};

export const useContextualPlans = ({ featureName }: UseContextualPlansProps) => {
  const { currentPlan, isFetching: isFetchingCurrentPlan } = useSubscriptionPlanTier();
  const { firstPlanWithFeature, isFetching: isFetchingFirstPlanWithFeature } = useFirstPlanWithFeature(featureName);

  const { planName: upgradePlanName } = usePlanInfo({ planId: firstPlanWithFeature?.id });

  const content = useContextualMessages({ featureName, upgradePlanName });

  const isFetching = isFetchingCurrentPlan || isFetchingFirstPlanWithFeature;

  if (currentPlan && firstPlanWithFeature) {
    return {
      isFetching,
      upsell: {
        title: content.title,
        description: content.description,
        currentContextualPlan: content.plans.current,
        upgradeContextualPlan: content.plans.upgrade,
        currentPlan,
        upgradePlan: firstPlanWithFeature,
      },
    };
  }

  return { isFetching };
};
